import { LabelPageSize } from "generated-graphql/graphql";

/** The physical page size the label renders at. Chosen on screen, shown in
 * the preview, and sent to the export so the downloaded PDF is the size the
 * preview showed. */
export type LabelSizeOption = "4x6" | "letter";

/** "Small"/"Large" name the size by feel, not by dimension -- the dimensions
 * themselves ("4 × 6 in", "Letter") live in the Download cluster's caption. */
export const LABEL_SIZE_OPTIONS: { value: LabelSizeOption; label: string }[] = [
  { value: "4x6", label: "Small" },
  { value: "letter", label: "Large" },
];

export const PREVIEW_SIZE_BY_LABEL_SIZE: Record<LabelSizeOption, "sm" | "lg"> = {
  "4x6": "sm",
  letter: "lg",
};

/** What the export mutation calls the same two sizes. */
export const PAGE_SIZE_BY_LABEL_SIZE: Record<LabelSizeOption, LabelPageSize> = {
  "4x6": LabelPageSize.FourBySix,
  letter: LabelPageSize.Letter,
};
